<template>
    <div class="container">
        <app-banner role="banner"/>

        <breadcrumb :to="breadcrumbTo" :useOffset="false"></breadcrumb>

        <div class="transition-root" key="connecting">
            <div class="row">
                <loading-indicator>Forbinder..</loading-indicator>
            </div>
        </div>

        <!--<div class="license-input" v-if="!connecting && !checkingLicense && !licenseCorrect">
            <div>
                <img :src="teacherIconUrl"/>
            </div>
            <div>
                <strong>Skriv licens</strong>
            </div>
            <div>
                <input type="text"
                       v-model="license"
                       v-on:change="onLicenseChange"
                       v-on:keydown="onLicenseChange"
                       v-on:keyup="onLicenseChange"/>
            </div>
            <div class="mt-3">
                <app-button v-on:onClick="clickConnect">OK</app-button>
            </div>

        </div>

        <transition-group mode="out-in" name="fade">
            <div class="transition-root" key="connecting" v-else-if="false && connecting">
                <div class="row">
                    <loading-indicator>Forbinder..</loading-indicator>
                </div>
            </div>
            <div class="transition-root" key="checkingLicense" v-if="false && checkingLicense">
                <div class="row">
                    <loading-indicator>Checker licens..</loading-indicator>
                </div>
            </div>
            <div class="transition-root" key="licenseCorrect" v-if="false && licenseCorrect">
                <div class="row">
                    <loading-indicator>Licens korrekt - starter spil..</loading-indicator>
                </div>
            </div>
        </transition-group>-->
    </div>
</template>

<script>
    import PlayerType from '@/enum/PlayerType'
    import GameClientEvent from '@/enum/GameClientEvent'
    import LicenseStatus from '@/enum/LicenseStatus'
    import Breadcrumb from '@/components/breadcrumb'
    import LoadingIndicator from '@/components/loading-indicator/index'
    import {CurrentUrlInfo} from '@/current-url-info'
    import AppConfig from '@/app-config'
    import * as MutationTypes from '@/store/mutation-types'
    import AppBanner from '@/components/app-banner'
    import GamePhase from '@/enum/GamePhase'
    import GameType from "@/enum/GameType";
    import {mapGetters} from 'vuex'
    import AppButton from "@/components/app-button/index";
    import {MediaUtil} from "@/utils/MediaUtil";
    import {$eBus} from '@/event-bus/index'

    export default {
        components: {
            AppButton,
            LoadingIndicator,
            AppBanner,
            Breadcrumb
        },
        computed: {
            ...mapGetters({
                storeLicense: 'getLicense'
            }),
            breadcrumbTo() {
                return '/';
            }
        },
        data() {
            let currentUrlInfo = CurrentUrlInfo.instance()

            let apiHost = AppConfig.apiHost || currentUrlInfo.getCurrentHost();
            let apiPort = AppConfig.apiPort || currentUrlInfo.getCurrentPort();
            let apiSecure = AppConfig.apiSecure || currentUrlInfo.getCurrentScheme() === 'https';

            let colyseusHost = AppConfig.colyseusHost || apiHost;
            let colyseusPort = AppConfig.colyseusPort;
            let colyseusSecure = AppConfig.colyseusSecure || false;

            return {
                connecting: false,
                connected: false,
                checkingLicense: false,
                licenseCorrect: false,
                license: null,
                teacherIconUrl: MediaUtil.getMediaUrl('emojis/emoji-nerd-240x240.png'),

                apiHost: apiHost,
                apiPort: apiPort,
                apiSecure: apiSecure,

                colyseusHost: colyseusHost,
                colyseusPort: colyseusPort,
                colyseusSecure: colyseusSecure,
            }
        },
        mounted() {
            if (this.storeLicense) {
                this.license = this.storeLicense;

                this.tryConnect();
            }
        },
        methods: {
            onLicenseChange(e) {
                e = e || window.event;

                let charCode = e.which || e.keyCode;

                if (this.license.length < 6) {
                    if (charCode >= 48 && charCode <= 57) {
                        return true;
                    }
                }

                // Always allow "backspace" and "delete"
                if (charCode === 8 || charCode === 46) {
                    return true;
                }

                e.preventDefault();
                e.stopPropagation();

                return false;
            },
            clickConnect() {
                this.tryConnect();
            },
            tryConnect() {
                this.connecting = true;

                if (this.$gameClient) {
                    this.connect();
                } else {
                    console.log('Game client not yet found.. waiting till next tick and trying again!');

                    this.$nextTick(() => {
                        this.tryConnect();
                    })
                }
            },
            connect() {
                this.connecting = true;
                this.connected = false;
                this.checkingLicense = false;
                this.licenseCorrect = false;

                console.log({
                    colyseusHost: this.colyseusHost,
                    colyseusPort: this.colyseusPort,
                    colyseusSecure: this.colyseusSecure,

                    apiHost: this.apiHost,
                    apiPort: this.apiPort,
                    apiSecure: this.apiSecure,
                });

                this.$gameClient.setUrlFromHostPort(this.colyseusHost, this.colyseusPort, this.colyseusSecure);
                this.$apiClient.setBaseUrlFromHostPort(this.apiHost, this.apiPort, this.apiSecure);

                this.$store.commit(MutationTypes.SET_LICENSE, this.license)

                this.$gameClient.createRoom(null, {
                    licenseKey: this.license,
                    playerType: PlayerType.Teacher,

                    _gameType: GameType.ClassRoom,
                    _phase: GamePhase.Setup,
                }).then(room => {
                    this.connected = true;
                    this.connecting = false;
                    this.checkingLicense = true;

                    const checkLicenseOnRoomStateChange = (room, state) => {
                        console.log('License status ', state.licenseInfo.status);

                        if (state.licenseInfo.status) {
                            this.checkingLicense = false;

                            $eBus.$off(GameClientEvent.RoomStateChange, checkLicenseOnRoomStateChange)

                            if (state.licenseInfo.status === LicenseStatus.Confirmed) {
                                console.log('License was correct, changing phase to SelectTheme');

                                this.licenseCorrect = true;

                                this.$gameClient.send({
                                    _phase: GamePhase.SelectTheme
                                });
                            } else if (state.licenseInfo.status === LicenseStatus.Error) {
                                this.connected = false;

                                // License wasn't correct
                                this.$store.commit(MutationTypes.SET_ERROR_ICON, 'connectionError')
                                this.$store.commit(MutationTypes.SET_ERROR_MESSAGE, state.licenseInfo.error)

                                this.$gameClient.disconnect();
                            } else {
                                console.log('Unknown license info status???');
                            }
                        }
                    };

                    $eBus.$on(GameClientEvent.RoomStateChange, checkLicenseOnRoomStateChange)
                }).catch(err => {
                    console.log('could not connect to server', err);

                    // Could not connect to server
                    this.$store.commit(MutationTypes.SET_ERROR_ICON, 'connectionError')
                    this.$store.commit(MutationTypes.SET_ERROR_MESSAGE, 'Kunne ikke forbinde til serveren')

                    this.connected = false;
                    this.connecting = false;
                    this.checkingLicense = false;
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@less/variables.less";

    .license-input {
        text-align: center;

        font-family: "Titillium Web", sans-serif;
        font-size: 30pt;

        input {
            padding: 10px 25px;
            letter-spacing: 30pt;
            text-indent: 50pt;
        }

        button {
            width: 100%;
        }
    }
</style>
